// extracted by mini-css-extract-plugin
export var alignBaseline = "_u-9";
export var alignCenter = "_u-5";
export var alignFlexEnd = "_u-7";
export var alignFlexStart = "_u-6";
export var alignSelfBaseline = "_u-e";
export var alignSelfCenter = "_u-a";
export var alignSelfFlexEnd = "_u-c";
export var alignSelfFlexStart = "_u-b";
export var alignSelfStretch = "_u-d";
export var alignStretch = "_u-8";
export var column = "_u-2";
export var columnReverse = "_u-4";
export var flex = "_u-0";
export var justifyCenter = "_u-f";
export var justifyFlexEnd = "_u-h";
export var justifyFlexStart = "_u-g";
export var justifySpaceAround = "_u-j";
export var justifySpaceBetween = "_u-i";
export var justifySpaceEvenly = "_u-k";
export var row = "_u-1";
export var rowReverse = "_u-3";
export var wrapNowrap = "_u-m";
export var wrapWrap = "_u-l";
export var wrapWrapReverse = "_u-n";